<template>
  <div class="container page-container">
      <!-- 顶部导航区域 -->
      <div class="top-container">
        <timePanel style="flex: 1"></timePanel>
        <h1 class="title" style="flex: 1">新泰农批市场实时大数据</h1>
        <date-box style="flex: 1"></date-box>
        <button class="backBtn" @click="back" type="primary">返回</button>
      </div>
      <!-- 底部大盒子 -->
      <div class="bottom-container">
        <!-- 左侧三个容器 -->
        <div class="column">
          <div class="row">
            <marketTradePage></marketTradePage>
          </div>
          <div class="row">
            <marketValumePage></marketValumePage>
          </div>
          <div class="row">
            <marketLeasePage></marketLeasePage>
          </div>
        </div>
        <!-- 中间两个容器 -->
        <div class="column" style="flex-basis: 40% !important">
          <div class="row row-2">
            <marketMapePage></marketMapePage>
          </div>
          <div class="row">
            <marketVehiclePage></marketVehiclePage>
          </div>
        </div>
        <!-- 右侧三个容器 -->
        <div class="column">
          <div class="row">
            <marketTradeAmountPage></marketTradeAmountPage>
          </div>
          <div class="row">
            <marketSinglePage></marketSinglePage>
          </div>
          <div class="row">
            <marketPricePage></marketPricePage>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import marketTradePage from "../components/marketTrade.vue";
import marketValumePage from "../components/marketValume.vue";

import marketPricePage from "../components/marketPrice.vue";
import marketSinglePage from "../components/marketSingleValume.vue";
import marketTradeAmountPage from "../components/marketTradeAmount.vue";
import marketVehiclePage from "../components/marketVehicle.vue";
import marketLeasePage from "../components/marketLease.vue";
import marketMapePage from "../components/marketMap.vue";

import dateBox from "../pages/dateBox.vue";
import timePanel from "../pages/timePanel";

export default {
  computed: {
  },
  components: {
    marketSinglePage,
    marketPricePage,
    marketTradeAmountPage,
    marketVehiclePage,
    marketValumePage,
    marketLeasePage,
    marketMapePage,
    marketTradePage,
    dateBox,
    timePanel,
  },
  data() {
    return {
      nowTime: "", //当前时间
      selected: 1,
    };
  },

  methods: {
    /**
     * 返回上一级
     */
    back(){
      window.history.go(-1)
    }
  },
};
</script>

<style scoped>
.container {
  width: var(--width);
  height: var(--height);
  overflow: hidden;
  background-image: url(@/assets/images/bg-1.png);
  background-repeat: round;
  position: relative;
}

.backBtn{
  width:60px;
  height:40px;
  border-radius: 10px;
  font-size: 19px;
  color: #fff;
  background: #466dc9;
  position: absolute;
  top: 45px;
  right: 90px;
}

.top-container {
  height: calc(var(--height) * 0.075);
  display: flex;
  justify-content: space-around;
}
.top-container .title {
  text-align: center;
  margin-top: calc(var(--height) * 0.003);
  font-size: calc(var(--height) * 0.04);
  color: #fff;
}
.bottom-container {
  height: calc(var(--height) * 0.925);
  width: calc(var(--width) * 0.96);
  padding-left: calc(var(--width) * 0.02);
  display: flex;
  justify-content: space-between;
  position: relative;
}

.bottom-container .column {
  flex-basis: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: calc(var(--width) * 0.005);
}

.bottom-container .column .row {
  width: 100%;
  height: 33.33%;
}

.bottom-container .column .row-2 {
  height: 66.66%;
}
</style>
